export const categories = [
  { id: 1, name: '恋爱', slug: 'romance', icon: 'ri-heart-line', description: '甜蜜浪漫的恋爱韩漫故事' },
  { id: 2, name: '动作', slug: 'action', icon: 'ri-sword-line', description: '热血激情的动作韩漫作品' },
  { id: 3, name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line', description: '充满想象力的奇幻韩漫世界' },
  { id: 4, name: '悬疑', slug: 'thriller', icon: 'ri-search-eye-line', description: '扣人心弦的悬疑推理韩漫' },
  { id: 5, name: '日常', slug: 'slice-of-life', icon: 'ri-sun-line', description: '温馨治愈的日常韩漫故事' },
  { id: 6, name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line', description: '轻松幽默的搞笑韩漫作品' },
  { id: 7, name: '都市', slug: 'urban', icon: 'ri-building-line', description: '现代都市背景下的人生百态' },
  { id: 8, name: '古风', slug: 'historical', icon: 'ri-scroll-line', description: '唯美古风穿越韩漫故事' },
];